
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Search } from "lucide-react";
import { useCharacterRolesFromDB } from "@/hooks/useCharacterRolesFromDB";

interface CharacterFiltersProps {
  speciesFilter: string;
  setSpeciesFilter: (value: string) => void;
  roleFilter: string;
  setRoleFilter: (value: string) => void;
  searchTerm: string;
  setSearchTerm: (value: string) => void;
}

export const CharacterFilters = ({
  speciesFilter,
  setSpeciesFilter,
  roleFilter,
  setRoleFilter,
  searchTerm,
  setSearchTerm,
}: CharacterFiltersProps) => {
  const { data: dynamicRoles = [], isLoading: rolesLoading } = useCharacterRolesFromDB();

  const speciesOptions = [
    { value: "all", label: "All Species" },
    { value: "iguana", label: "Iguana" },
    { value: "toucan", label: "Toucan" },
    { value: "squirrel", label: "Squirrel" },
    { value: "chicken", label: "Chicken" },
    { value: "human", label: "Human" },
  ];

  const roleOptions = [
    { value: "all", label: "All Roles" },
    ...dynamicRoles
  ];

  return (
    <div className="bg-white rounded-xl shadow-lg p-6 space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
          <Input
            placeholder="Search characters..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pl-10"
          />
        </div>

        <Select value={speciesFilter} onValueChange={setSpeciesFilter}>
          <SelectTrigger>
            <SelectValue placeholder="Filter by species" />
          </SelectTrigger>
          <SelectContent>
            {speciesOptions.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <Select value={roleFilter} onValueChange={setRoleFilter} disabled={rolesLoading}>
          <SelectTrigger>
            <SelectValue placeholder={rolesLoading ? "Loading roles..." : "Filter by role"} />
          </SelectTrigger>
          <SelectContent>
            {roleOptions.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};
